import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = () => {
    return (
        <Helmet>
            <meta charset="utf-8" />
            <title>
                CryptoZone
            </title>
            <meta name="description" content="" />
            {/* responsive tag */}
            <meta httpEquiv="x-ua-compatible" content="ie=edge" />
            {/* Bootstrap Latest compiled and minified CSS  */}
            <link
                href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
                rel="stylesheet"
                integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
                crossorigin="anonymous"
            />
            <link
                href="https://fonts.googleapis.com/css?family=Poppins:600%2C700%2C500%7CRoboto:400&display=swap"
                rel="stylesheet"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
            />
        </Helmet>
    )
}

export default MetaTags
